import { z } from 'zod'

import {
  AdmissionGroupStatus,
  AdmissionGroupType,
} from '../constants/admissionGroup'

export const omniSearchTypeSchema = z.enum([
  'customers',
  'admissionGroups',
  'events',
])

export type OmniSearchType = z.infer<typeof omniSearchTypeSchema>

export const omniSearchQuerySchema = z.object({
  search: z.string().trim().min(3).max(500),
  venueId: z.string(),
  date: z.coerce.date().optional(),
  limit: z.coerce.number().int().min(1).max(25).optional(),
  types: z
    .union([omniSearchTypeSchema, z.array(omniSearchTypeSchema)])
    .optional()
    .transform((value) => {
      if (value === undefined) return undefined
      return Array.isArray(value) ? value : [value]
    }),
})

export type OmniSearchQuery = z.infer<typeof omniSearchQuerySchema>

export const omniSearchCustomerHitSchema = z.object({
  id: z.string(),
  name: z.string(),
  email: z.string().nullish(),
  phone: z.string().nullish(),
  profileImage: z.string().nullish(),
  subtitle: z.string().optional(),
})

export const omniSearchAdmissionGroupHitSchema = z.object({
  id: z.string(),
  name: z.string(),
  type: z.nativeEnum(AdmissionGroupType),
  date: z.coerce.date(),
  venueId: z.string(),
  subtitle: z.string().optional(),
  status: z.nativeEnum(AdmissionGroupStatus).optional(),
  guestsExpected: z.number().nullish(),
  tableNames: z.array(z.string()).optional(),
})

export const omniSearchEventHitSchema = z.object({
  id: z.string(),
  name: z.string(),
  date: z.coerce.date(),
  venueId: z.string(),
  primaryImage: z.string().nullish(),
})

export const omniSearchDataSchema = z.object({
  customers: z.array(omniSearchCustomerHitSchema),
  admissionGroups: z.array(omniSearchAdmissionGroupHitSchema),
  events: z.array(omniSearchEventHitSchema),
})

export const omniSearchResponseSchema = z.object({
  data: omniSearchDataSchema,
})

export type OmniSearchCustomerHit = z.infer<typeof omniSearchCustomerHitSchema>
export type OmniSearchAdmissionGroupHit = z.infer<
  typeof omniSearchAdmissionGroupHitSchema
>
export type OmniSearchEventHit = z.infer<typeof omniSearchEventHitSchema>
export type OmniSearchData = z.infer<typeof omniSearchDataSchema>
export type OmniSearchResponse = z.infer<typeof omniSearchResponseSchema>
